<template>
  <ul class="logoList">
    <ServiceLogo image-src="/images/contents/logo_study_sapuri_high.png" class="logoListItemHighSchool" />
    <ServiceLogo image-src="/images/contents/logo_study_sapuri_university.png" class="logoListItemUniversity" />
  </ul>
</template>

<script>
import ServiceLogo from './ServiceLogo.vue';

export default {
  name: 'ServiceLogoList',
  components: {
    ServiceLogo,
  },
};
</script>

<style lang="scss" scoped>
.logoList {
  display: flex;

  .logoListItemHighSchool {
    height: 15px;
  }

  .logoListItemUniversity {
    margin-left: 20px;
    height: 15px;
  }
}
</style>
